// extracted by mini-css-extract-plugin
module.exports = {"completeBtn":"ClientSignature_completeBtn__1TBE2"};